// ** Third Party Components
import Chart from 'react-apexcharts';

// ** Reactstrap Imports
import { Card, CardHeader, CardTitle, CardBody } from 'reactstrap';

const ApexRadialbar = ({ data }) => {
  const donutColors = {
    series1: '#ffe700',
    series2: '#00d4bd',
    series3: '#826bf8',
    series4: '#2b9bf4',
    series5: '#FFA1A1'
  };

  // ** Chart Options
  const options = {
    colors: [donutColors.series1, donutColors.series2, donutColors.series4],
    plotOptions: {
      radialBar: {
        size: 185,
        hollow: {
          size: '25%'
        },
        track: {
          margin: 15
        },
        dataLabels: {
          name: {
            fontSize: '2rem',
            fontFamily: 'Geist'
          },
          value: {
            fontSize: '1rem',
            fontFamily: 'Geist',
            formatter(val) {
              return val;
            }
          },
          total: {
            show: true,
            fontSize: '1rem',
            label: data.totalGenderTop.name,
            formatter() {
              return `${data.totalGenderTop.data}`;
            }
          }
        }
      }
    },
    grid: {
      padding: {
        top: -35,
        bottom: -30
      }
    },
    legend: {
      show: true,
      position: 'bottom'
    },
    stroke: {
      lineCap: 'round'
    },
    labels: data.genders.labels
  };

  return (
    <Card>
      <CardHeader className="d-flex flex-sm-row flex-column justify-content-md-between align-items-start justify-content-start">
        <CardTitle tag="h4">Género</CardTitle>
      </CardHeader>
      <CardBody>
        <Chart
          options={options}
          series={data.genders.datasets.map((item) => item.data[0])}
          type="radialBar"
          height={350}
        />
      </CardBody>
    </Card>
  );
};

export default ApexRadialbar;
